import * as React from 'react';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import { Icon, InputNumber, Select, DatePicker, Slider, Checkbox, Tooltip, Modal, message, Input, Spin } from 'antd';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter, getAllDataResetFilter } from 'src/actions/discoverRatesActions';
import { weightOptions, localsFilter, GridView, directServices, serviceLabelMap } from './DiscoverRateUtils';
import { useDebounce } from 'src/hooks/useDebounce';
import Form, { FormComponentProps } from 'antd/lib/form';
import moment from 'moment';
import { FreightPrice } from './TypesInDiscoverRates/FreightPrice';
import { TransitDays } from './TypesInDiscoverRates/TransitDays';
import { FetchedFilters } from './TypesInDiscoverRates/FetchedFilters';
import { ShippingLines } from '../RateMaster/TypesInRateMaster/ShippingLines';
import { SelectedFilters } from './TypesInDiscoverRates/SelectedFilters';
import { LabelValueObject, ObjectIdNamePair } from 'src/components/common/Types/CommonTypes';
import classnames from 'classnames';
import Search from 'antd/lib/input/Search';
import { FFList, POLPODPairData } from './TypesInDiscoverRates/SearchResult';
import { isValidArray, clone } from 'src/Library/Helper';
import { DiscoverRatesFiltersStyles } from './DiscoverRatesFilters.styes';
import { tokens } from 'src/design-system';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import { fetchAddresses } from 'src/api/organisationProfiling';
import { SEConsignorAddress } from '../shipment-execution/SE.interfaces';
import { InquiryModes, UserRole } from 'src/Library/Constants';
import { globalAirlines } from 'src/selectors/importsFilter';
import DiscoverRatesServicesFilterDetails from './DiscoverRatesServicesFilterDetails';
import FieldRate from 'src/components/common/form/FieldRate';
import { renderSelectDropDown } from 'src/Library/Common';

interface DiscoverRatesFiltersProps extends FormComponentProps {
  classes: {
    [X in keyof ReturnType<typeof DiscoverRatesFiltersStyles>]: string
  };
  selectedFilters: SelectedFilters;
  getAllDataSetFilter: (val, apiCall?) => void;
  freightPrice: FreightPrice;
  transitDays: TransitDays;
  currencySymbols: { [key: string]: string; };
  shippingLines: ShippingLines [];
  airlines: ShippingLines [];
  fetchedFilters: FetchedFilters;
  getAllDataResetFilter: (apiCall? : boolean) => void;
  isLocalsPresent: boolean;
  activeKey: string;
  orgType: string;
  ffList: FFList [];
  searchFilters: SearchFilters;
  gridPorts: any;
  portList: Record<string, POLPODPairData>;
  stuffingAndDestuffingLocation: string[];
  disableRateDiscoveryServicesLinking: boolean;
  stuffingAddressesList: SEConsignorAddress[];
  destuffingAddressesList: SEConsignorAddress[];
  mode: InquiryModes;
  vendorRating: string[];
  vendorRatingMap: {
    [key: number]: string;
  }
  setVendorRatingFilter: (selectedVendorRating: string[]) => void;
  selectedVendorRating: string[];
  userRole: UserRole;
  showMarkupCriteria: boolean;
  teams: ObjectIdNamePair[];
  fetchingShippers: boolean;
  onSearchShipper: (query: string) => void;
  stakeholderList: Array<{ key: string; label: string }>;
  customerList: Array<{ key: string; label: string }>;
  fetchingStakeholders: boolean;
  fetchingCustomers: boolean;
  onSearchStakeholder: (query: string) => void;
  onSearchCustomer: (query: string) => void;
}

interface StateProps {
  weightValue: number;
  noOfContainer: number;
  filteredFFList: FFList [];
  showServiceModal: boolean;
  service?: {key: string, type?: string[], serviceType?: string};
  stuffingAddresses: SEConsignorAddress[];
  deStuffingAddresses: SEConsignorAddress[];
  loader: boolean;
}

const { useEffect, useState } = React;

const DiscoverRatesFilters = (props: DiscoverRatesFiltersProps): React.ReactElement => {

  const {
    classes,
    selectedFilters,
    getAllDataSetFilter,
    form,
    freightPrice,
    transitDays,
    shippingLines,
    airlines,
    fetchedFilters,
    getAllDataResetFilter,
    isLocalsPresent,
    activeKey,
    orgType,
    ffList,
    searchFilters,
    gridPorts,
    portList,
    disableRateDiscoveryServicesLinking,
    stuffingAddressesList,
    destuffingAddressesList,
    mode,
    vendorRating,
    vendorRatingMap,
    setVendorRatingFilter,
    selectedVendorRating,
    userRole,
    showMarkupCriteria,
    teams,
    fetchingShippers,
    onSearchShipper,
    stakeholderList = [],
    customerList = [],
    fetchingStakeholders = false,
    fetchingCustomers = false,
    onSearchStakeholder,
    onSearchCustomer,
  } = props;

  const [state, setState] = useState<StateProps>({
    weightValue: 0,
    noOfContainer: 0,
    filteredFFList: [],
    showServiceModal: false,
    stuffingAddresses: [],
    deStuffingAddresses: [],
    loader: false,
  });

  const {
    weightValue,
    noOfContainer,
    filteredFFList,
    service,
    showServiceModal,
    stuffingAddresses,
    deStuffingAddresses,
    loader
  } = state;

  const isModeTypeRoadDomestic = mode === InquiryModes.DOMESTIC; // label is ROAD and value is DOMESTIC
  const isModeTypeTrailer = mode === InquiryModes.TRAILER; // label is ROAD and value is DOMESTIC
  const setStateUtil = (newState: Partial<StateProps>) => {
    setState((oldState: StateProps) => {
      return {
        ...oldState,
        ...newState,
      };
    });
  };

  const debouncedContainerValue = useDebounce(noOfContainer, 500);
  const debouncedWeightValue = useDebounce(weightValue, 500);

  const setContainer = (val) => {
    getAllDataSetFilter({ noOfContainers: val,
      freightPrice: null });
  };

  const isFilterDisabled = () => {
    if (searchFilters?.viewType === GridView.GRID) {
      return Object.keys(portList)?.some(key => portList[key].isLoading)
    }
    return;
  }

  useEffect(() => { 
    (orgType === 'SHIPPER' && !disableRateDiscoveryServicesLinking && loadAddresses());
  }, [])
  
  useEffect(() => {
    (orgType === 'SHIPPER' && disableRateDiscoveryServicesLinking) && setStateUtil({ stuffingAddresses: stuffingAddressesList });
  }, [stuffingAddressesList]);

  useEffect(() => {
    (orgType === 'SHIPPER' && disableRateDiscoveryServicesLinking) && setStateUtil({ deStuffingAddresses: destuffingAddressesList });
  }, [destuffingAddressesList]);

  useEffect(() => {
    setStateUtil({ filteredFFList: ffList });
  }, [ffList]);

  useEffect(() => {
    form.setFieldsValue({
      stakeholderFilter: selectedFilters?.stakeholderId,
      customerFilter: selectedFilters?.customerId,
    });
  }, [selectedFilters?.stakeholderId, selectedFilters?.customerId]);

  useEffect(() => {
    form.setFieldsValue({
      transitDays: [transitDays?.min || 0, transitDays?.max || 0],
      weightValue: undefined,
      freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0],
      validUpto: undefined,
      noOfContainer: 1,
    });
  }, [searchFilters.view]);

  useEffect(() => {
    if (!(selectedFilters.freightPrice)) {
      form.setFieldsValue({
        freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0],
      })
    }
    if (!(selectedFilters.transitDays)) {
      form.setFieldsValue({
        transitDays: [transitDays?.min || 0, transitDays?.max || 0],
      })
    }
  }, [searchFilters.viewType]);

  const isFilterApplied = () => {
    return selectedFilters?.noOfContainers > 1 ||
      selectedFilters?.rateType?.length ||
      !!selectedFilters?.validityEnd ||
      selectedFilters?.route?.length ||
      ((selectedFilters?.transitDays?.min || selectedFilters?.transitDays?.min === 0)
        && selectedFilters?.transitDays?.max) ||
      ((selectedFilters?.freightPrice?.min || selectedFilters?.freightPrice?.min === 0)
        && selectedFilters?.freightPrice?.max) ||
      selectedFilters?.carrierList?.length ||
      !!selectedFilters?.stakeholderId ||
      !!selectedFilters?.customerId;
  }

  useEffect(() => {
    if (searchFilters?.viewType === GridView.GRID && !isFilterDisabled() && !isFilterApplied()) {
      form.setFieldsValue({
        transitDays: [transitDays?.min || 0, transitDays?.max || 0],
        weightValue: undefined,
        freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0],
        validUpto: undefined,
        noOfContainer: 1,
      });
    }
  }, [isFilterDisabled()]);

  useEffect(
    () => {
      if (debouncedWeightValue) {
        setWeight(debouncedWeightValue);
      }
    },
    [debouncedWeightValue],
  );

  useEffect(
    () => {
      if (debouncedContainerValue) {
        setContainer(debouncedContainerValue);
      }
    },
    [debouncedContainerValue],
  );

  useEffect(
    () => {
      if (searchFilters?.viewType === GridView.GRID) {
        getAllDataSetFilter({ noOfContainers: 1 }, false);
        form.setFieldsValue({ noOfContainer: 1 });
      }
    },
    [searchFilters?.viewType],
  );

  useEffect(
    () => {
      form.setFieldsValue({
        freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0]
      });
    },
    [freightPrice],
  );

  const setWeight = (val) => {
    getAllDataSetFilter({ weight : {
      unit: form.getFieldValue('weightUnit'),
      value: val,
    }});
  };

  const handleContainerCountChange = (val) : void => {
    getAllDataSetFilter({ noOfContainers: selectedFilters.noOfContainers + val,
      freightPrice: null });
    form.setFieldsValue({
      noOfContainer: selectedFilters.noOfContainers + val,
    });
  };

  const renderTotalContainer = () : React.ReactElement => {
    const containerCount = form.getFieldValue('noOfContainer') || selectedFilters.noOfContainers;
    return (
      <div className={classes.cardStyle}
        style={{
          pointerEvents: searchFilters?.viewType !== GridView.GRID ? 'unset' : 'none',
        }}>
        <div>Total {searchFilters.mode === InquiryModes.DOMESTIC ? 'Vehicles' : 'Containers'}</div>
        <Tooltip
          title={
            <div className={classes.containerTooltip}>
              <Icon type="warning"
                theme="filled" className={classes.tooltipIcon} />
              You can't add more<br/>than 1000 {searchFilters.mode === InquiryModes.DOMESTIC ? 'vehicles' : 'containers'}
            </div>
          }
          placement="right"
          visible={containerCount > 1000}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon type="minus"
              style={{ color: (selectedFilters.noOfContainers === 1 || searchFilters?.viewType === GridView.GRID)
                ? '#D9D9D9' : '#333333' }}
              onClick={() => selectedFilters.noOfContainers !== 1 &&
                handleContainerCountChange(-1)} />
            <span className={classes.noOfContainers}>
            <Form.Item style={{ marginBottom: 0 }}>
              {form.getFieldDecorator('noOfContainer', {
                initialValue: selectedFilters.noOfContainers,
              })(
                <InputNumber min={1}
                  max={1000}
                  type="number"
                  className={classnames(classes.weightInput, classes.containerInput)}
                  style={{ width: `${16 * containerCount?.toString()?.length}px` || '38px' }}
                  onChange={(val: number) => setStateUtil({ noOfContainer: Math.min(val, 1000) })}
                />,
              )}
            </Form.Item>
            </span>
            <Icon type="plus"
              style={{ color: (selectedFilters.noOfContainers === 1000 || searchFilters?.viewType === GridView.GRID)
                ? '#D9D9D9' : '#333333' }}
              onClick={() => selectedFilters.noOfContainers < 1000  &&
                handleContainerCountChange(1)} />
          </div>
        </Tooltip>
      </div>
    );
  };

  // const renderWeightFilter = () : React.ReactElement => {
  //   return (
  //     <div className={classes.cardStyle} style={{ paddingRight: 0 }}>
  //       <div>Weight</div>
  //       <div>
  //         {form.getFieldDecorator('weightValue', {
  //           initialValue: selectedFilters.weight?.value,
  //         })(
  //           <InputNumber className={classes.weightInput}
  //           type="number"
  //           placeholder="00"
  //           onChange={val => setStateUtil({ weightValue: val })}
  //          />,
  //         )}
  //         {form.getFieldDecorator('weightUnit', {
  //           initialValue: selectedFilters.weight?.unit,
  //         })(
  //           <Select
  //             className={classes.weightSelect}
  //             dropdownClassName={classes.selectDropdown}
  //             onChange={(val) => {
  //               getAllDataSetFilter({ weight : {
  //                 key: val,
  //                 value: form.getFieldValue('weightValue'),
  //               } });
  //             }}
  //             >
  //             {weightOptions.map(item => (
  //               <Select.Option key={item}
  //                 disabled={item === 'lbs' || item === 'kg'}>{item}</Select.Option>
  //             ))}
  //           </Select>,
  //         )}
  //       </div>
  //     </div>
  //   );
  // };

  const renderValidUpto = () : React.ReactElement => {
    return (
      <div className={classes.cardStyle}>
        <div className={classes.centerDiv}>Date <Tooltip title={
          <div style={{ fontSize: '11px', textAlign: 'center' }}>
            Add Sailing Date, Gate-in Date or Cargo Ready Date.
            <div style={{ marginTop: '4px' }}>
              All the rates valid on this date will be visible
            </div>
          </div>
        }
        overlayStyle={{ width: '190px' }}
        >
          <Icon type="exclamation-circle" theme="filled" style={{ marginLeft: '5px' }} />
          </Tooltip></div>
        {form.getFieldDecorator('validUpto', {
          initialValue: selectedFilters.validityEnd ? moment(selectedFilters.validityEnd) :
          undefined,
        })(
          <DatePicker
          className={classes.datepicker}
          format="DD MMM YYYY"
          onChange={(val) => {
            getAllDataSetFilter({ validityEnd: val?.format('YYYY-MM-DD') || null },
            searchFilters?.viewType !== GridView.GRID);
          }}
        />,
        )}
      </div>
    );
  };

  const renderLocationFilter = (type: string) : React.ReactElement => {
    let displayAddress: string = '';
    if (type === 'origin') {
      stuffingAddresses?.forEach(item => {
        if (item && `${item.id}` === selectedFilters.stuffingLocationId) {
          displayAddress = item.displayAddress;
        }
      });
    }
    if (type === 'destination') {
      deStuffingAddresses?.forEach(item => {
        if (item && `${item.id}` === selectedFilters.destuffingLocationId) {
          displayAddress = item.displayAddress;
        }
      });
    }
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>{type === 'origin' ? 'Stuffing' : 'De-stuffing'} Location</div>
          <span className={classes.transitDays}
              style={{ color: getColor(selectedFilters.transitDays, transitDays) }}
              onClick={() => {
                setStateUtil({showServiceModal: true, service: {
                  key: type === 'origin' ? 'originServices' : 'destinationServices', 
                  serviceType: 'Transportation Service'
                }});
              }}>Select</span>
          </div>
        {displayAddress?.length > 0 && (
          <Tooltip title={displayAddress}>
            <div
              style={{ 
                marginTop: '10px',
                display: 'flex', 
                flexDirection: 'row', 
                paddingLeft: '5px',
              }}
            >
              <span style={{
                fontWeight: 600, 
                color: '#333333', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap',
                width: '85%',
              }}>{displayAddress}</span>
              <Icon
                type="close"
                style={{
                  color: '#DC3C42',
                  cursor: 'pointer',
                  flexDirection: 'row-reverse',
                  marginLeft: '5%',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  getAllDataSetFilter({
                    [type === 'origin' ? 'stuffingLocationId': 'destuffingLocationId']: undefined,
                    [type === 'origin' ? 'stuffingType': 'destuffingType']: undefined,
                    [type === 'origin' ? 'stuffingWeight': 'destuffingWeight']: undefined,
                  },
                  true);
                }}
              />
            </div>
          </Tooltip>
        )}
      </div>
    );
  };

  const handleReset = (type) : void => {
    selectedFilters[type] && getAllDataSetFilter({ [type]: null }, searchFilters?.viewType !== GridView.GRID );
  };

  const getColor = (type, initial?) : string => {
    if (type && initial) {
      return (type.min !== initial.min || type.max !== initial.max) ? '#DC3C42' : '#D9D9D9';
    }
    return (type && type.length) > 0 ? '#DC3C42' : '#D9D9D9';
  };

  const handleSliderChange = (min, max, type, title) : void => {
    if (min === Math.floor(type.min) && max === Math.ceil(type.max)) {
      getAllDataSetFilter({ [title]: null }, searchFilters?.viewType !== GridView.GRID);
    } else {
      getAllDataSetFilter({ [title]: {
        min,
        max,
      } }, searchFilters?.viewType !== GridView.GRID);
    }
  };

  const renderTransitDays = () : React.ReactElement => {
    const { min: minRange, max: maxRange } = transitDays || {};
    const marks = transitDays && {
      [minRange]: minRange,
      [maxRange]: maxRange,
    };
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Transit Days</div>
          <span className={classes.transitDays}
            style={{ color: getColor(selectedFilters.transitDays, transitDays) }}
            onClick={() => {
              handleReset('transitDays');
              form.setFieldsValue({
                transitDays: [transitDays?.min || 0, transitDays?.max || 0],
              });
            }}>Reset</span>
        </div>
        {form.getFieldDecorator('transitDays', {
          initialValue: [selectedFilters?.transitDays?.min || transitDays?.min,
            selectedFilters?.transitDays?.max || transitDays?.max],
        })(
          <Slider
            disabled={!transitDays}
            marks={marks}
            range={true} min={transitDays?.min} max={transitDays?.max}
            onAfterChange={(val : any) => {
              const [min, max] = val;
              handleSliderChange(min, max, transitDays, 'transitDays');
            }}
            className={classes.slider}
          />,
        )}
      </div>
    );
  };

  const renderFreightPrice = () : React.ReactElement => {
    const { currencySymbols } = props;
    const { min: minRange, max: maxRange } = freightPrice || {};
    const marks = freightPrice && {
      [Math.round(minRange)]: `${currencySymbols[freightPrice?.currency]}${Math.round(minRange)}`,
      [Math.round(maxRange)]: `${currencySymbols[freightPrice?.currency]}${Math.round(maxRange)}`,
    };
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Freight Price</div>
          <span style={{ color: getColor(selectedFilters.freightPrice, freightPrice),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              handleReset('freightPrice');
              form.setFieldsValue({
                freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0],
              });
            }}>Reset</span>
        </div>
        {form.getFieldDecorator('freightPrice', {
          initialValue: [selectedFilters?.freightPrice?.min || freightPrice?.min,
            selectedFilters?.freightPrice?.max || freightPrice?.max],
        })(
           <Slider
           disabled={!freightPrice}
           marks={marks}
           range={true} min={freightPrice?.min} max={freightPrice?.max}
           onAfterChange={(val: any) => {
             const [min, max] = val;
             handleSliderChange(min, max, freightPrice, 'freightPrice');
           }}
           className={classes.slider}
         />,
        )}
      </div>
    );
  };

  const convertToCheckboxArray = (array, isArrayOfString = false, fieldKey = '') => {
    const checkboxArray : LabelValueObject [] = [];
    array?.forEach((item) => {
      if (isArrayOfString){
        checkboxArray.push({
          value: item,
          label:
            serviceLabelMap[item] || (fieldKey === 'source' && item === 'SPOT' ? 'CONTRACT' : item),
        });
      } else { 
        checkboxArray.push({ value: item.key,label: item.label });
      }
    });
    return checkboxArray;
  };

  const convertToFieldRating = ({options, labels}) => {
    return options?.map((opt) => {
      const obj = {
        value: opt,
        label: <div></div>
      }
      if (+opt) {
        obj.label = (<Tooltip title={labels[+opt - 1]}>
            <FieldRate
              value={opt}
              disabled={true}
              tooltips={[]}
              styles={{ fontSize: '14px' }}
              labelStyles={{ fontWeight: 500, fontSize: '12px', fontStyle: 'italic' }}
              isView={true}
            />
          </Tooltip>);
      } else {
        obj.label = <span>No Rating</span>
      }
      return obj
    });
  };

  const renderViewRates = () : React.ReactElement => {
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>View Rates</div>
          <span style={{ color: getColor(selectedFilters.rateType),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              selectedFilters.rateType?.length && handleReset('rateType');
            }}>Reset</span>
        </div>
        <Checkbox.Group
          className={classes.shippingLines}
          options={convertToCheckboxArray(fetchedFilters.rateTypes)}
          value={selectedFilters.rateType}
          onChange={checkedValues =>
            getAllDataSetFilter({ rateType: checkedValues }, searchFilters?.viewType !== GridView.GRID)
          } />
      </div>
    );
  };

  const renderRoutes = () : React.ReactElement => {
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Routes</div>
          <span style={{ color: getColor(selectedFilters.route),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              selectedFilters.route?.length && handleReset('route');
            }}>Reset</span>
        </div>
        <Checkbox.Group
          className={classes.shippingLines}
          options={convertToCheckboxArray(fetchedFilters.routes)}
          value={selectedFilters.route}
          onChange={checkedValues =>
            getAllDataSetFilter({ route: checkedValues }, searchFilters?.viewType !== GridView.GRID)
          } />
      </div>
    );
  };

  const getShippingLines = () => {
    const carriers : LabelValueObject [] = [];
    (searchFilters.mode === InquiryModes.AIRCARGO ? airlines : shippingLines)?.forEach((item) => {
      carriers.push({
        value: item.dbId,
        label: item.name,
      });
    });
    return carriers;
  };

  const renderShippingLines = (): React.ReactElement => {
    const shippingLinesFilterLabel = searchFilters.mode === InquiryModes.AIRCARGO
      ? 'Air Lines'
      : 'Shipping Lines';
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            {shippingLinesFilterLabel}
            {selectedFilters.carrierList?.length ? ` (${selectedFilters.carrierList.length})` : ''}
          </div>
          <span
            style={{
              color: getColor(selectedFilters.carrierList),
              fontWeight: 600,
              cursor: 'pointer',
            }}
            onClick={() => {
              getAllDataSetFilter({ carrierList: [] }, false);
            }}
          >
            Reset
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Checkbox.Group
            options={getShippingLines()}
            className={classes.shippingLines}
            value={selectedFilters.carrierList}
            onChange={(checkedValues) => getAllDataSetFilter({ carrierList: checkedValues }, false)}
          />
        </div>
      </div>
    );
  };

  const renderBusinessTypeFilter = () => {
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Business Type</div>
          <span style={{ color: getColor(selectedFilters.businessTypes),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              selectedFilters.businessTypes?.length && handleReset('businessType');
            }}>Reset</span>
        </div>
        <Checkbox.Group
          className={classes.shippingLines}
          options={convertToCheckboxArray(fetchedFilters.businessTypes, true)}
          value={selectedFilters.businessTypes}
          onChange={checkedValues =>
            getAllDataSetFilter({ businessType: checkedValues }, searchFilters?.viewType !== GridView.GRID)
          } />
      </div>
    );
  }

  const resetFilters = () : void => {
    getAllDataResetFilter(searchFilters?.viewType !== GridView.GRID);
    form.setFieldsValue({
      transitDays: [transitDays?.min || 0, transitDays?.max || 0],
      weightValue: undefined,
      freightPrice: [freightPrice?.min || 0, freightPrice?.max || 0],
      validUpto: undefined,
      noOfContainer: 1,
    });
    getAllDataSetFilter({ ffIdsList: [] }, false);
  };

  const renderFilters = () : React.ReactElement => {
    return (
      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontWeight: 600, color: tokens.colors.textSecondary }}>Filters
        <span className={classes.clearAllButton}
          onClick={() => resetFilters()}>Clear All</span></div>
      </div>
    );
  };

  const renderLocals = () : React.ReactElement => {
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Locals</div>
          <span style={{ color: getColor(selectedFilters.excludeLocalCategoryList),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              selectedFilters.excludeLocalCategoryList?.length
              && handleReset('excludeLocalCategoryList');
            }}>Reset</span>
        </div>
        <Checkbox.Group
          className={classes.shippingLines}
          options={localsFilter}
          value={selectedFilters.excludeLocalCategoryList}
          onChange={checkedValues =>
            getAllDataSetFilter({ excludeLocalCategoryList: checkedValues })
          } />
      </div>
    );
  };

  const handleSearchFF = (queryString) => {
    const clonedFilteredFFList = clone(ffList);
    const searchedFFs = isValidArray(clonedFilteredFFList) ?
      clonedFilteredFFList.filter(ff => (
        ff?.name?.toLowerCase().includes(queryString.toLowerCase())
      )) : [];
    setStateUtil({ filteredFFList: searchedFFs });
  };

  const handleFFCheckboxChange = (val) => {
    const { ffIdsList } = selectedFilters;
    const clonedCheckedFFIds = ffIdsList ? clone(ffIdsList) : [];
    let ffIds : string [] = clonedCheckedFFIds;
    if (val.target.checked) {
      ffIds.push(val.target.id);
    } else {
      ffIds = clonedCheckedFFIds?.filter(ff => ff !== val.target.id) || [];
    }
    getAllDataSetFilter({ ffIdsList: ffIds }, false);
  };

  const renderFFFilter = () => {
    const { ffIdsList } = selectedFilters;
    const ffFilterlabel = (isModeTypeRoadDomestic || isModeTypeTrailer) ? 'Carriers' : 'Freight Forwarder';
    const placeholder = (isModeTypeRoadDomestic || isModeTypeTrailer) ? 'Search Carrier' : 'Search FF';
    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>{ffFilterlabel} {ffIdsList?.length ? `(${ffIdsList.length})` : ''}</div>
          <span className={classes.transitDays}
            style={{ color: getColor(ffIdsList) }}
            onClick={() => {
              getAllDataSetFilter({ ffIdsList: [] }, false);
            }}>Reset</span>
        </div>
        {form.getFieldDecorator('ffList')(
          <Search
            className={classes.search}
            placeholder={placeholder}
            onChange={(e) => handleSearchFF(e.target.value)}
          />,
        )}
          <div className={classes.ffListDiv}>
            {isValidArray(filteredFFList) && filteredFFList.map(ff => (
              <span className={classes.ffList}>
                <Checkbox id={ff.id}
                  className={classes.ffCheckbox}
                  checked={ffIdsList?.some(id => id === ff.id)}
                  onChange={val => handleFFCheckboxChange(val)}
                >{ff.name}</Checkbox>
                <span className={classes.ffType}>{(isModeTypeRoadDomestic || isModeTypeTrailer) ? '' : renderLinkingStatus(ff.linkingStatus)}</span>
              </span>
            ))}
          </div>
        <div>
        </div>
      </div>
    );
  };

  const handleServiceModal = () => {
    setStateUtil({showServiceModal: !state.showServiceModal})
  }

  const loadAddresses = async () => {
    setStateUtil({ loader: true });
    let stuffingAddresses : SEConsignorAddress[]= [];
    let deStuffingAddresses : SEConsignorAddress[] = [];
    const stuffing = await fetchAddresses({ addressType: 'STUFFING', fetchAll: true });
    if (stuffing.isSuccess) {
      stuffingAddresses = stuffing.data?.filter((item) => !!item.address) || [];
    }
    const deStuffing = await fetchAddresses({ addressType: 'DESTUFFING', fetchAll: true });
    if (deStuffing.isSuccess) {
      deStuffingAddresses = deStuffing.data?.filter((item) => !!item.address) || [];
    }
    setStateUtil({ stuffingAddresses, deStuffingAddresses, loader: false });
  };

  const handleStuffingSubmit = () => {
    props.form.validateFields((err, values) => {
      if (err) return;
      const {key, type } = service!;
      const { stuffingType, stuffingLocationId, destuffingType, destuffingLocationId } = values
      let stuffingWeight, destuffingWeight;
      if (values.stuffingWeight) stuffingWeight = { unit: values.stuffingUnit, value: +values.stuffingWeight }
      if (values.destuffingWeight) destuffingWeight = { unit: values.destuffingUnit, value: +values.destuffingWeight }

      getAllDataSetFilter({ [key]: type, 
        ...(stuffingType && {stuffingType}), ...(stuffingLocationId && {stuffingLocationId}), 
        ...(destuffingType && {destuffingType}), ...(destuffingLocationId && {destuffingLocationId}), 
        ...(stuffingWeight && {stuffingWeight}), ...(destuffingWeight && {destuffingWeight})}, 
        true)
      setStateUtil({showServiceModal: false})
    });
  }

  const handleServiceCheckBox = (key, oldServiceType: string[] = [], newServiceType: string[] = []) => {
    const dataToSend: {added?: string[], removed?: string[]} = {};
    // Since check return whole array of selected string.
    // So we need to filter which values is added or deleted.
    // below code gets the removed and added value from checkBox group.
    dataToSend.added = newServiceType?.filter(val => !oldServiceType?.includes(val));
    dataToSend.removed = oldServiceType?.filter(val => !newServiceType?.includes(val));
    const { added, removed } = dataToSend;

    const stuffingDestuffingIndependentServices = [...directServices, ...[searchFilters.mode === InquiryModes.FCL ? [] : 'Custom Clearance Service']];

    //directServices includes services that can directly be added without specifying stuffing/De-Stuffing address
    if (stuffingDestuffingIndependentServices.includes(added?.[0]) || stuffingDestuffingIndependentServices.includes(removed?.[0])){
      getAllDataSetFilter({ [key]: newServiceType }, true)
    } else if (removed?.length){
      // if neither transport or custom key is selected then we remove type location and weight
      // else if one of them is present then we don't remove the stuff/De-Stuff keys
      const remove = new Set([...stuffingDestuffingIndependentServices, ...newServiceType]).size === stuffingDestuffingIndependentServices.length;
      const isOrigin = key === 'originServices';
      getAllDataSetFilter({ [key]: newServiceType, 
        ...((isOrigin && remove) && {stuffingType: undefined}), ...((isOrigin && remove) && {stuffingLocationId: undefined}), ...((isOrigin && remove) && {stuffingWeight: undefined}),
        ...((!isOrigin && remove) && {destuffingType: undefined}), ...((!isOrigin && remove) && {destuffingLocationId: undefined}), ...((!isOrigin && remove) && {destuffingWeight: undefined})},
         true)
    }
    // check whether to show modal if added value is transport or custom (if FCL mode)
    const showServiceModal = !!added?.length && (!stuffingDestuffingIndependentServices.includes(added?.[0]))
    setStateUtil({ showServiceModal, service: { key, type: newServiceType, serviceType: added?.[0] } })
  }

  const renderCheckboxFilter = (label, fieldKey) => {
    const services = ['originServices', 'destinationServices', 'rating']
    const isOrigin = fieldKey === 'originServices';
    const isVendorRating = fieldKey === 'rating';
    const fetchedFilterMap = {
      originServices: fetchedFilters.originServices, 
      destinationServices: fetchedFilters.destinationServices,
      source: fetchedFilters.rateDiscoverySource,
      rating: {
        options: Object.keys(vendorRatingMap || {})?.reverse(),
        labels: [...vendorRating]?.reverse()
      }
    }
    if (isVendorRating) {
      fetchedFilterMap[fieldKey].options.push('0')
      fetchedFilterMap[fieldKey].labels.push('No Rating')
    }
    const serviceSelection = fetchedFilterMap[fieldKey];

    return (
      <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>{label}</div>
          <span style={{ color: getColor(selectedFilters?.[fieldKey]),
            fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              if (services.includes(fieldKey)){
                getAllDataSetFilter({ 
                  [fieldKey]: directServices,
                  [isOrigin ? 'stuffingType' : 'destuffingType']: undefined,
                  [isOrigin ? 'stuffingLocationId' : 'destuffingLocationId']: undefined,
                  [isOrigin ? 'stuffingWeight' : 'destuffingWeight']: undefined,
                 }, true )
              } else {
                selectedFilters?.[fieldKey]?.length && handleReset(fieldKey);
              }
            }}>Reset</span>
        </div>
        <Checkbox.Group
          className={classes.shippingLines}
          options={isVendorRating ? convertToFieldRating(serviceSelection) : convertToCheckboxArray(serviceSelection, true, fieldKey)}
          value={isVendorRating ? selectedVendorRating : selectedFilters?.[fieldKey]}
          onChange={(type: string[]) => {
            if (!['originServices', 'destinationServices'].includes(fieldKey)){
              if (fieldKey === 'rating') {
                setVendorRatingFilter(type)
              } else {
                getAllDataSetFilter({ [fieldKey]: type }, true)
              }
            } else { 
              handleServiceCheckBox(fieldKey, selectedFilters?.[fieldKey], type); 
            }
          }} />
      </div>
    );
  };

  const renderStuffingModal = () => {
    return <Modal 
        title={service?.serviceType??'Details'}
        visible
        onCancel={handleServiceModal}
        width={420}
        okText='Confirm'
        onOk={handleStuffingSubmit}
      >
        {loader ? <Spin style={{ marginLeft: '48%' }} /> :
        <React.Fragment>
          {<p style={{fontSize: 12}}>Please fill the details below</p>}
          <DiscoverRatesServicesFilterDetails
            service={service}
            form={form}
            stuffingAddresses={stuffingAddresses}
            deStuffingAddresses={deStuffingAddresses}
            mode={searchFilters.mode}
          />
      </React.Fragment>}
    </Modal>
  }

  const renderLinkingStatus = (status) => {
    switch (status) {
      case 'NON_LINKED': return 'Non-Linked FF'; 
      case 'REQUESTED': return 'Requested'; 
      default: return 'My FF'; 
    }
  };

  const renderMyTeamSelect = () => {
    if (userRole === UserRole.ADMIN && showMarkupCriteria && orgType === 'SHIPPER') {
      return <div className={classes.cardStyle} style={{ display: 'block' }}>
        <div>Shipper</div>
        <Form.Item style={{ marginTop: '8px', marginBottom: 0 }}>
          {form.getFieldDecorator('myTeam', {
            initialValue: searchFilters?.shipperTeamId
          })(
            <Select
              getPopupContainer={(trigger: any) => trigger.parentNode}
              style={{ width: '100%', fontWeight: 600 }}
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder="Select Shipper"
              onSearch={(searchShipperQuery) => onSearchShipper(searchShipperQuery)}
              onFocus={() => onSearchShipper('')}
              optionLabelProp={'data-value'}
              dropdownRender={menu => renderSelectDropDown(menu, fetchingShippers)}
              onChange={(shipperTeamId: string) => getAllDataSetFilter({ shipperTeamId }, true)}>
              {isValidArray(teams) && teams.map(shipper => (
                <Select.Option key={shipper.id} data-value={shipper.name}>
                  {shipper.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
    }
    return null;
  }

  const renderStakeholderFilter = () => (
    <div className={classes.cardStyle} style={{ display: 'block' }}>
      <div>Stakeholder</div>
      <Form.Item style={{ marginTop: '8px', marginBottom: 0 }}>
        {form.getFieldDecorator('stakeholderFilter', {
          initialValue: selectedFilters?.stakeholderId
        })(
          <Select
            getPopupContainer={(trigger: any) => trigger.parentNode}
            style={{ width: '100%', fontWeight: 600 }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Select Stakeholder"
            onSearch={(q) => onSearchStakeholder && onSearchStakeholder(q)}
            onFocus={() => onSearchStakeholder && onSearchStakeholder('')}
            optionLabelProp={'data-value'}
            dropdownRender={(menu) => renderSelectDropDown(menu, fetchingStakeholders)}
            onChange={(stakeholderId: string) => getAllDataSetFilter({ stakeholderId: stakeholderId || undefined }, true)}
          >
            {isValidArray(stakeholderList) && stakeholderList.map((item) => (
              <Select.Option key={item.key} data-value={item.label}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    </div>
  );

  const renderCustomerFilter = () => (
    <div className={classes.cardStyle} style={{ display: 'block' }}>
      <div>Customer</div>
      <Form.Item style={{ marginTop: '8px', marginBottom: 0 }}>
        {form.getFieldDecorator('customerFilter', {
          initialValue: selectedFilters?.customerId
        })(
          <Select
            getPopupContainer={(trigger: any) => trigger.parentNode}
            style={{ width: '100%', fontWeight: 600 }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Select Customer"
            onSearch={(q) => onSearchCustomer && onSearchCustomer(q)}
            onFocus={() => onSearchCustomer && onSearchCustomer('')}
            optionLabelProp={'data-value'}
            dropdownRender={(menu) => renderSelectDropDown(menu, fetchingCustomers)}
            onChange={(customerId: string) => getAllDataSetFilter({ customerId: customerId || undefined }, true)}
          >
            {isValidArray(customerList) && customerList.map((item) => (
              <Select.Option key={item.key} data-value={item.label}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
    </div>
  );

  const renderVendorRatingFilter = () => {
    if (!vendorRating?.length) return null;
    return renderCheckboxFilter('Vendor Rating', 'rating')
  }
  return (
    <div className={classes.mainDiv}>
      {renderFilters()}
      {orgType === 'FF' && activeKey === 'BUY' && !(isModeTypeRoadDomestic || isModeTypeTrailer) && renderViewRates()}
      {renderStakeholderFilter()}
      {renderCustomerFilter()}
      {
        orgType === 'SHIPPER' && <React.Fragment>
          {renderMyTeamSelect()}
          {renderVendorRatingFilter()}
          {/* { isRoadDomesticMode && renderBusinessTypeFilter()} */}
          { (disableRateDiscoveryServicesLinking && (stuffingAddressesList?.length > 0 || isModeTypeRoadDomestic || isModeTypeTrailer)) && renderLocationFilter('origin')}
          { (disableRateDiscoveryServicesLinking && (destuffingAddressesList?.length > 0 || isModeTypeRoadDomestic || isModeTypeTrailer) ) && renderLocationFilter('destination')}
          { isValidArray(fetchedFilters.originServices) && renderCheckboxFilter('Origin Services Selection', 'originServices') }
          { isValidArray(fetchedFilters.destinationServices) && renderCheckboxFilter('Destination Services Selection','destinationServices') }
          { (isValidArray(ffList) || isModeTypeRoadDomestic || isModeTypeTrailer) && renderFFFilter() }
          { isValidArray(fetchedFilters.rateDiscoverySource) && !(isModeTypeRoadDomestic || isModeTypeTrailer) && renderCheckboxFilter('Source','source') }
        </React.Fragment>
      }
      {([InquiryModes.FCL, InquiryModes.DOMESTIC, InquiryModes.TRAILER].includes(searchFilters.mode)) && renderTotalContainer()}
      {/* {renderWeightFilter()} */}
      {renderValidUpto()}
      {!(isModeTypeRoadDomestic || isModeTypeTrailer) && renderRoutes()}
      {transitDays?.min !== transitDays?.max && renderTransitDays()}
      {isLocalsPresent && searchFilters.viewType !== 'GRID' && !(isModeTypeRoadDomestic || isModeTypeTrailer) && renderLocals()}
      {!(isModeTypeRoadDomestic || isModeTypeTrailer) && freightPrice?.min !== freightPrice?.max && renderFreightPrice()}
      {!(isModeTypeRoadDomestic || isModeTypeTrailer) && renderShippingLines()}
      { showServiceModal && renderStuffingModal() }
    </div>
  );
};

const mapStateToProps = ({ discoverRatesReducer, masterData }, ownProps) => ({
  selectedFilters: discoverRatesReducer.selectedFilters,
  searchFilters: discoverRatesReducer.searchFilters,
  ffList: discoverRatesReducer.ffList,
  freightPrice: discoverRatesReducer.freightPrice,
  transitDays: discoverRatesReducer.transitDays,
  currencySymbols: masterData.currencySymbols,
  shippingLines: masterData.globalShippingLines,
  airlines: globalAirlines(masterData),
  fetchedFilters: discoverRatesReducer.fetchedFilters,
  orgType: masterData.userData.type,
  gridPorts: discoverRatesReducer.gridPorts,
  portList: discoverRatesReducer.portList,
  stuffingAndDestuffingLocation: masterData.stuffingAndDestuffingLocation,
  disableRateDiscoveryServicesLinking: masterData.modules.disable_rate_discovery_services_linking || false,
  stuffingAddressesList: discoverRatesReducer.stuffingAddressesList,
  destuffingAddressesList: discoverRatesReducer.destuffingAddressesList,
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
  vendorRatingMap: masterData?.vendorRating?.mapping,
  userRole: masterData.userData.role,
  showMarkupCriteria: masterData?.modules?.show_markup_criteria,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllDataSetFilter, getAllDataResetFilter },
    dispatch,
  );

const DiscoverRatesFiltersStyled = withStyles(DiscoverRatesFiltersStyles)
  (Form.create()(DiscoverRatesFilters));
export default connect(mapStateToProps, mapDispatchToProps)(DiscoverRatesFiltersStyled);
